<!-- JWNET未加入業者form -->
<template>
  <div>
    <v-tabs
      v-model="traderForm"
      background-color="blue lighten-4"
      centered
      icons-and-text
      fixed-tabs
    >
      <v-tabs-slider />

      <v-tab href="#tab-basic">
        事業者
        <v-icon>mdi-bank</v-icon>
      </v-tab>

      <v-tab
        href="#tab-locations"
        :disabled="!masterTrader"
      >
        事業場
        <v-icon>mdi-factory</v-icon>
      </v-tab>

    </v-tabs>
    <v-tabs-items v-model="traderForm">
      <v-tab-item value="tab-basic">
        <basic-form :is-edit="true" @callbackToParent="callbackToParent" />
      </v-tab-item>

      <v-tab-item value="tab-locations">
        <location-form :master-trader="masterTrader" />
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
  import BasicForm from "./forms/_Basic"
  import LocationForm from "./forms/_Location"
  export default {
    name: 'MasterTraderForm',
    components: {
      BasicForm,
      LocationForm,
    },
    mixins: [],
    props: {
      masterTrader: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        traderForm: 'basicTab',
      }
    },
    computed: {},
    methods: {
      callbackToParent () {
        this.$emit('editCallback')
      }
    },
  }
</script>

<style lang="scss">
  .v-window-item > .v-card
  {
    min-height:300px;
  }
</style>
